const l = { ExampleFlag: { description: "Example of a feature flag", enabled: !1 }, EnableLibrariesSearch: { description: "Enable search functionality in the Save to Library menu", enabled: !1 } };
function r() {
  e().clear();
}
function o(a) {
  return !!t(a) && (e().set(a, !1), !0);
}
function u(a) {
  return !!t(a) && (e().set(a, !0), !0);
}
function f(a, n) {
  return !!t(a) && (e().set(a, n), !0);
}
function i(a) {
  Object.entries(a).forEach(([n, s]) => e().set(n, s.enabled));
}
function c(a) {
  return t(a) && !!e().get(a);
}
function t(a) {
  return e().has(a);
}
function e() {
  return window.__afs_flag_status;
}
window.__afs_flag_status || (window.__afs_flag_status = /* @__PURE__ */ new Map()), i(l);
export {
  r as clearFlags,
  o as disableFlag,
  u as enableFlag,
  c as isFlagEnabled,
  t as isValidFlag,
  i as loadFlagData,
  f as toggleFlag
};
//# sourceMappingURL=FeatureFlag.js.map
